import { apiFGTS } from '../http/httpClient'
import { PartnerType } from '@/app/utils/partners.enum'
export interface createTransactionBody {
  value: number
  customerId: string
  CodigoTabela: string
  CodigoProduto: number
  CodigoEmpregador: number
  CodigoOrg: number
  Prazo: number
  pin?: string
}

interface createTransactionResponse {
  contract: string
  value: number
  status: string
  seller: string
  customer: string
  _id: string
  createdAt: string
  updatedAt: string
  __v: number
}
export async function createTransaction(body: createTransactionBody) {
  const { data } = await apiFGTS
    .post<createTransactionResponse>(`/transaction`, body, {
      journey: PartnerType.FGTS,
    })
    .catch((err) => {
      throw err?.response?.data || err
    })

  return data
}
